import { IApplicationState } from '../../../../types/types';
import { IUserBoardActivityTimes } from '../types';

export const getUserBoardActivityTimes = (
    state: IApplicationState
): IUserBoardActivityTimes => {
    return state.model.boardUserActivityTimes;
}
